import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageText from "../common/imageText";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";

class ShoppingPopup extends Component {
  /**************
   * Properties *
   **************/
  state = {
    orthoPatient: {
      gift_shop: {
        id: "popup",
        src: require("./images/orthoPatient/1350_popup_Exit_GiftShop_all.png"),
      },
      medical: {
        id: "popup",
        src: require("./images/orthoPatient/1350_popup_Exit_Medical_all.png"),
      },
    },
    chfPatient: {
      gift_shop: {
        id: "popup",
        src: require("./images/chfPatient/1350_popup_Exit_GiftShop_all.png"),
      },
      medical: {
        id: "popup",
        src: require("./images/chfPatient/1350_popup_Exit_Medical_all.png"),
      },
    },
    pediatricPatient: {
      gift_shop: {
        id: "popup",
        src: require("./images/pediatricPatient/1350_popup_Exit_GiftShop_all.png"),
      },
      medical: {
        id: "popup",
        src: require("./images/pediatricPatient/1350_popup_Exit_Medical_all.png"),
      },
    },
  };

  handleOnKeyUp = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "Enter":
        this.props.history.push("/retail_shopping");
        break;
      case "B":
      case "b":
        this.props.history.push(
          "/retail_shopping/revenue_center/" + this.props.match.params.name
        );
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let patient = null;
    switch (this.props.currentPatient) {
      case "orthoPatient":
        patient = this.state.orthoPatient;
        break;
      case "chfPatient":
        patient = this.state.chfPatient;
        break;
      case "pediatricPatient":
        patient = this.state.pediatricPatient;
        break;
      default:
        patient = this.state.orthoPatient;
    }
    return (
      <div className="service-1350">
        <ImageText {...patient[this.props.match.params.name]} />
      </div>
    );
  }
}

const ConnectedShoppingPopup = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(ShoppingPopup);

export default withRouter(ConnectedShoppingPopup);
